
const { ccclass, property, requireComponent } = cc._decorator;
import Utility from "../../../../utility/utility";
import GameUtil from "../../../../utility/game_util";
import CustomUIStateSwitcher from "../../../public/ui/custom_ui_state_switcher";
import TimeManager from "../../../../manager/time_manager";
import AudioManager from "../../../../manager/audio_manager";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import TableClock from "../../components/table_clock";

class SpriteCache{
    private m_spriteFrame: cc.SpriteFrame
    private m_refreshTime: number
    private m_key: string
    constructor(key: string, spriteFrame: cc.SpriteFrame){
        this.m_spriteFrame = spriteFrame
        this.refreshTime()
    }

    getSpriteFrame(): cc.SpriteFrame{
        this.refreshTime()
        return this.m_spriteFrame
    }

    getKey(){
        return this.m_key
    }

    getRefreshTime(): number{
        return this.m_refreshTime
    }

    release(){
        let spriteFrame = this.m_spriteFrame
        if(spriteFrame){            
            let tex = spriteFrame.getTexture()
            if(tex){
                tex.destroy()
            }
            spriteFrame.clearTexture()
            spriteFrame.destroy()
        }
        this.m_spriteFrame = null
    }

    private refreshTime(){
        this.m_refreshTime = new Date().getTime()
    }
}

class SpriteCacheManager{
    private m_maxCount;
    private m_map;
    constructor(maxCount: number){
        this.m_maxCount = maxCount
        this.m_map = {}
    }
    
    addSpriteFrame(key: string, spriteFrame: cc.SpriteFrame){
        this.m_map[key] = new SpriteCache(key, spriteFrame)
    }
    
    findSpriteFrame(key: number|string): cc.SpriteFrame{
        let spritCache = this.m_map[key] as SpriteCache
        if(spritCache == null){
            return null
        }
        return spritCache.getSpriteFrame()
    }

    cleanExcessCaches(){
        let cacheList = new Array<SpriteCache>();
        for (const key in this.m_map) {
            if (this.m_map.hasOwnProperty(key)) {
                const element = this.m_map[key];
                if(element){
                    cacheList.push(element)
                }                
            }
        }
        if(cacheList.length < this.m_maxCount){
            return
        }
        cacheList.sort(function(a, b){
            return b.getRefreshTime() - a.getRefreshTime()
        })
        for (let index = this.m_maxCount - 1; index < cacheList.length; index++) {
            const element = cacheList[index];
            let key = element.getKey()
            // element.release()
            this.m_map[key] = null;
        }
    }

    cleanAllCaches(){
        for (const key in this.m_map) {
            if (this.m_map.hasOwnProperty(key)) {
                const element = this.m_map[key];
                if(element){
                    element.release()
                }                
            }
        }
        this.m_map = {}
    }
}

@ccclass
@requireComponent(CustomUIStateSwitcher)
export default abstract class PokerTableSeatBaseView extends cc.Component{

    static s_avatarSpriteCacheManager: SpriteCacheManager = new SpriteCacheManager(20);

    @property(cc.Sprite)  //未坐下图标
    spriteNoSeatDown: cc.Sprite = null

    @property(cc.Node)  
    nodeRoleInfo: cc.Node = null

    @property(cc.Node)
    avatarNodeParent: cc.Node = null

    @property(cc.Sprite)  //掉线
    spriteOffLine: cc.Sprite = null

    @property(cc.Sprite)  //暂时离开
    spriteTmpLeave: cc.Sprite = null

    @property(cc.Sprite)    //准备图标
    spriteReady: cc.Sprite = null

    @property(cc.Button)
    buttonNotSeat: cc.Button = null

    @property(cc.Button)
    buttonKick: cc.Button = null

    @property(CustomUIStateSwitcher)
    styleUiStateSwitcher: CustomUIStateSwitcher = null

    @property(cc.Sprite)    //房主
    spriteOwner: cc.Sprite = null

    @property(cc.Sprite)    //庄家
    spriteBanker: cc.Sprite = null


    @property(cc.Prefab)
    tabelClockPrefab: cc.Prefab = null

    @property(cc.Node)
    nodeClockParent: cc.Node = null

    @property(cc.Node)
    nodeChatText: cc.Node = null

    @property(cc.Node)
    nodeChatEmoji: cc.Node = null

    @property(cc.Node)
    nodeSelect: cc.Node = null
    

    @property(CustomUIStateSwitcher)
    bgUiStateSwitcher: CustomUIStateSwitcher = null
    

    protected m_tableClock: TableClock = null

    protected mOnclickKickBtnCallback: Function = null
    protected mOnclickNotSeatBtnCallback: Function = null
    private m_clockScheduleId: number = 0
    onLoad(){
        let self = this
        if(this.styleUiStateSwitcher == null){
            this.styleUiStateSwitcher = this.getComponent<CustomUIStateSwitcher>(CustomUIStateSwitcher)
        }

        if(this.buttonKick != null){
            this.buttonKick.node.on('click', function(event: cc.Button){
                if(self.mOnclickKickBtnCallback){
                    self.mOnclickKickBtnCallback(self)
                }
            })
        }
        if(this.buttonNotSeat != null){
            this.buttonNotSeat.node.on('click', function(event: cc.Button){
                if(self.mOnclickNotSeatBtnCallback){
                    self.mOnclickNotSeatBtnCallback(self)
                }
            })
        }
    }

    reset(){

        this.showNoSeatDown(true)
        this.showRoleInfo(false)
        this.showOffLineTag(false)
        this.showTmpLeaveTag(false)
        this.showOwnerTag(false)
        this.showBankerTag(false)
        this.showReadyTag(false)
        this.setBgStyle(true)
    }



    showRoleInfo(show: boolean){
        this.nodeRoleInfo.active = show
    }

    showNoSeatDown(show: boolean, spriteFrame?: cc.SpriteFrame){
        this.spriteNoSeatDown.node.active = show        
        if(spriteFrame != null){
            this.spriteNoSeatDown.spriteFrame = spriteFrame
        }
    }

    showOffLineTag(show: boolean){
        if(this.spriteOffLine == null){
            return
        }
        this.spriteOffLine.node.active = show
    }

    showTmpLeaveTag(show: boolean){
        if(this.spriteTmpLeave == null){
            return
        }
        this.spriteTmpLeave.node.active = show
    }


    showOwnerTag(show: boolean){
        this.spriteOwner.node.active = show
    }

    showBankerTag(show: boolean){
        this.spriteBanker.node.active = show
    }

    showReadyTag(show: boolean){
        this.spriteReady.node.active = show
    }

    resetSeatStyle(index: number){
        this.styleUiStateSwitcher.SwitchState(this.getSeatStyleName(index))
    }

    showKickBtn(show:boolean){
        if(!this.buttonKick) return
        this.buttonKick.node.active = show
    }

    showSelect(show: boolean){
        if(!this.nodeSelect) return        
        this.nodeSelect.active = show
    }

    showClock(show: boolean, secs?: number, needShake?: boolean, onFinish?: Function, onTick?: Function){
        if(!this.m_tableClock){
            let node = cc.instantiate(this.tabelClockPrefab)
            node.parent = this.nodeClockParent
            node.position = cc.Vec2.ZERO
            this.m_tableClock = node.getComponent(TableClock)
        }
        this.m_tableClock.showClock(show, secs, needShake, onFinish, onTick)
    }



    setBgStyle(normal: boolean){
        this.bgUiStateSwitcher && this.bgUiStateSwitcher.SwitchState(normal? 'bgstyle1': 'bgstyle2')
    }



    enableNotSeatBtn(enable: boolean){
        if(!this.buttonNotSeat) return
        this.buttonNotSeat.enabled = enable
    }



    setClickNotSeatBtnListener(callback: Function){
        this.mOnclickNotSeatBtnCallback = callback
    }

    setClickKickBtnListener(callback: Function){
        this.mOnclickKickBtnCallback = callback
    }
    
    abstract getSeatStyleName(index: number):string;

    //文本对话显示在头像的右边 return 1; 文本对话显示在头像的左边 return 2
    getChatTextDir(): number{
        return this.nodeChatText.scaleX > 0 ? 1 : 2
    }

    getChatTextWorldPos(){
        return this.nodeChatText.parent.convertToWorldSpaceAR(this.nodeChatText.getPosition())
    }

    getChatEmojiWorldPos(){
        return this.nodeChatEmoji.parent.convertToWorldSpaceAR(this.nodeChatEmoji.getPosition())
    }

    onDestroy(){
        if(this.m_clockScheduleId > 0){
            TimeManager.instance.cancelSchedule(this.m_clockScheduleId)
            this.m_clockScheduleId = 0
        }
        this.unscheduleAllCallbacks()
    }
}
